import fetchServer from "../../fetchServer"

export default async function removeAirlineCommission(id) {
  let result = {return: 0,msg: 'Something went wrong removing airline commission!'}

  await fetchServer({method: 'DELETE',url: `/product/v1/airlineCommission/deleteAirlineCommission/${id}`})
  .then((res) => {
    if(res?.data && !res?.data?.error) {
      result = {return: 1,msg: 'Successfull',data: res?.data?.data}
    } else if(res?.data?.error) result['msg'] = res.data.error
  })
  .catch((err) => {
    console.log('Network Error!')
  })

  return result;
}